import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  // Optional: prevent background scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <div className="navbar">
        <button
          className="menu-toggle"
          aria-label="Open menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(true)}
        >
          ☰
        </button>

        <div className="navbar-title">
          <Link to="/" onClick={closeMenu}>
            VENUSIAN ROSE
          </Link>
        </div>

        <div className="navbar-star">✶</div>

        <nav className="navbar-links">
          <Link to="/about-me">About me</Link>
          <Link to="/my-practice">My Practice</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </div>

      {/* Mobile overlay menu */}
      <div className={`mobile-menu ${isOpen ? "is-open" : ""}`}>
        <div className="mobile-menu__panel">
          <button className="mobile-menu__close" aria-label="Close menu" onClick={closeMenu}>
            ✕
          </button>

          <nav className="mobile-menu__links">
            <Link to="/" onClick={closeMenu}>Home</Link>
            <Link to="/about-me" onClick={closeMenu}>About me</Link>
            <Link to="/my-practice" onClick={closeMenu}>My Practice</Link>
            <Link to="/contact" onClick={closeMenu}>Contact</Link>
          </nav>
        </div>

        {/* Click outside to close */}
        <button className="mobile-menu__backdrop" aria-label="Close menu" onClick={closeMenu} />
      </div>
    </>
  );
}

export default Navbar;
